import { useContext } from 'react';
import { ClassContext } from 'edrolo/context';
import { utils as u, enums, Button, Progress, Tooltip } from 'edrolo-ui';
import { ButtonLinkProps } from 'edrolo-ui/components/Button';
import { Lesson } from '../../../../../../../types/Assemblage';
import { useClassProgress } from 'edrolo/domains/bySchoolClass';

interface Props {
  lesson: Lesson;
  url: ButtonLinkProps['to'];
}

export const ProgressButton = ({ lesson, url }: Props) => {
  const {
    data: { classId },
  } = useContext(ClassContext);

  const { data, loading, error } = useClassProgress(classId);

  if (loading || error) {
    return null;
  }

  const avgCount = Math.round(
    data.lessons[lesson.id]?.chunk_visit_count_avg || 0
  );

  return (
    <Button.Link size={enums.Size.SMALL} variant={enums.Variant.GHOST} to={url}>
      <Tooltip
        tip={`Students have viewed an average of ${avgCount} out of ${lesson.chunks.length} lesson parts`}
      >
        <Progress.Circle
          numerator={avgCount}
          denominator={lesson.chunks.length}
          color={enums.ColorHue.BLUE}
          className={u.mr2}
        />
      </Tooltip>
      View progress
    </Button.Link>
  );
};
